import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Paper,
  Typography,
  CircularProgress,
  Box,
  Grid,
  Button,
  Divider,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import api from '../../globals/axios';
import { useAlert } from '../../components/Alert';

const DetailInvoiceView = () => {
  const { invoiceUUID } = useParams();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        const res = await api.get(
          `/app-admin/get-ca-farmer-subscriptions-invoice-detail/?uuid=${invoiceUUID}`
        );
        setInvoice(res.data.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setError('Failed to fetch invoice details.');
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [invoiceUUID]);

  const handleDownloadInvoice = () => {
    if (invoice?.invoice_link) {
      window.open(invoice.invoice_link, '_blank');
    } else {
      showAlert('error', 'Invoice not available');
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', mt: 10 }}>
        <Typography color="error">{error}</Typography>
        <Button variant="contained" sx={{ mt: 2 }} onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 1000, mx: 'auto', mt: 5, px: 2 }}>
      <Button
        variant="outlined"
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mb: 3 }}
      >
        Back
      </Button>

      <Paper sx={{ p: 4 }}>
        {/* Invoice Section */}
        <Typography variant="h6" gutterBottom>
          Invoice Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={1} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Typography>
              <strong>Invoice Number:</strong> {invoice.invoice_number}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Created At:</strong> {invoice.created_at}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Created By:</strong> {invoice.created_by}
            </Typography>
          </Grid>
        </Grid>

        {/* Order Section */}
        <Typography variant="h6" gutterBottom>
          Order Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={1} sx={{ mb: 3 }}>
          <Grid item xs={6}>
            <Typography>
              <strong>Order ID:</strong> {invoice.order_id}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Payment Mode:</strong> {invoice.payment_mode}
            </Typography>
          </Grid>
        </Grid>

        {/* Subscription Section */}
        <Typography variant="h6" gutterBottom>
          Subscription Info
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography>
              <strong>Farmer Name:</strong> {invoice.farmer_name || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Farm Name:</strong> {invoice.farm_name || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Phone Number:</strong> {invoice.phone_number || 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Base Amount:</strong> ₹
              {invoice.base_amount != null ? invoice.base_amount : 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>GST Amount:</strong> ₹
              {invoice.gst_amount != null ? invoice.gst_amount : 'N/A'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              <strong>Total Amount:</strong> ₹
              {invoice.amount != null ? invoice.amount : 'N/A'}
            </Typography>
          </Grid>
        </Grid>

        <Box sx={{ mt: 5 }}>
          <Button variant="contained" onClick={handleDownloadInvoice}>
            Download Invoice
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default DetailInvoiceView;
